'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _utils = require('../utils');

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var defaultClient = new _utils.HttpClient('http://api.mindself.com');

exports.default = function () {
  var http = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultClient;
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') return action(dispatch, getState);
        if (!http.defaultReqHeaders) {
          http.defaultReqHeaders = {};
        }
        if (action.type === 'MINDSELF_SET_CLIENT_DEFAULT_REQ_HEADERS') {
          Object.keys(action.headers).forEach(function (key) {
            var header = action.headers[key];
            http.defaultReqHeaders[key] = header;
          });
          return next(action);
        }
        if (action.type === 'MINDSELF_SET_AUTHORIZATION_INFO') {
          var _action$payload = action.payload,
              userId = _action$payload.userId,
              Authorization = _action$payload.Authorization;

          http.defaultReqHeaders.Authorization = Authorization;
          http.userId = userId;
          return next(action);
        }
        if (action.type !== 'CALL_MINDSELF_API') return next(action);

        var minselfAPICall = action.minselfAPICall,
            types = action.types,
            rest = _objectWithoutProperties(action, ['minselfAPICall', 'types']);

        if (!minselfAPICall) return next(action);

        var _types = _slicedToArray(types, 3),
            REQUEST = _types[0],
            SUCCESS = _types[1],
            FAILURE = _types[2];

        next(_extends({}, rest, { type: REQUEST }));

        return minselfAPICall(http, http.userId).then(function (result) {
          if (result.status % 200 >= 100) {
            var error = {
              status: result.status
            };
            if (result.data && result.data.message) {
              error.message = result.data.message;
            }
            return Promise.reject(error);
          }
          // Test
          if (process.env.NODE_ENV === 'test') {
            delete result.headers.date;
          }
          return result;
        }).then(function (_ref2) {
          var data = _ref2.data,
              headers = _ref2.headers;
          return next(_extends({}, rest, { result: data, headers: headers, type: SUCCESS }));
        }, function (error) {
          if (error.stack) {
            console.log('Error:', error);
          }
          return next(_extends({}, rest, { error: error, type: FAILURE }));
        });
      };
    };
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/mindself-api-client/lib/middlewares/api-call.js
// module id = 512
// module chunks = 1